export type PostOrder = {
  id: string;
  name: string;
  description?: string;
  orders?: string;
};

export type Target = {
  id: string;
  guard_id: string;
  guard_name: string;
  status: "pending" | "submitted" | "failed";
  submitted_at?: string | null;
  guardian_ref?: string | null;
  failure_reason?: string | null;
  already_checked_in?: boolean | null;
  not_checked_in?: boolean | null;
  checked_in_at?: string | null;
  post_orders?: PostOrder[];
  previous_handover?: string;
};

export type State = {
  session_id: string;
  kind: "checkin" | "checkout" | "incident";
  actor_phone: string;
  location_id?: string | null;
  due_by: string;
  expires_at: string;
  targets: Target[];
};

export async function loadState(otp: string): Promise<State> {
  const r = await fetch(`/c/${otp}/state`);
  if (!r.ok) throw new Error((await r.json()).error ?? `HTTP ${r.status}`);
  return r.json();
}

export type SubmitPayload = {
  lat: number;
  lng: number;
  accuracy: number;
  photo: Blob;
  // Check-in only: guard confirmed they've read the site's post orders.
  acknowledgePostOrders?: boolean;
  // Check-out only: free-text note for the next guard.
  handoverNote?: string;
  // Check-in only: forgot-to-checkout recovery — close the stale shift
  // using this same photo/geo first, then open the new one.
  forceCheckoutThenCheckin?: boolean;
};

export async function submitTarget(
  otp: string,
  targetId: string,
  payload: SubmitPayload,
): Promise<{ ok: boolean; guardian_ref?: string; already?: boolean }> {
  const fd = new FormData();
  fd.set("lat", String(payload.lat));
  fd.set("lng", String(payload.lng));
  fd.set("accuracy", String(payload.accuracy));
  fd.set("photo", payload.photo, "selfie.jpg");
  if (payload.acknowledgePostOrders) fd.set("acknowledge_post_orders", "true");
  if (payload.handoverNote) fd.set("handover_note", payload.handoverNote);
  if (payload.forceCheckoutThenCheckin) fd.set("force_checkout_then_checkin", "true");
  const r = await fetch(`/c/${otp}/target/${targetId}`, { method: "POST", body: fd });
  const body = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(body.error ?? `HTTP ${r.status}`);
  return body;
}
